function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#002F34"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 4.667c-1.102 0-2 .897-2 2h1.334a.668.668 0 011.333 0c0 .367-.299.666-.666.666L7.334 8v1.333h1.333v-.78a2.004 2.004 0 001.334-1.886c0-1.103-.898-2-2-2zM7.334 10.667a.667.667 0 111.334 0 .667.667 0 01-1.334 0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.333a6.667 6.667 0 10.001 13.334 6.667 6.667 0 000-13.334zm0 12A5.34 5.34 0 012.668 8a5.34 5.34 0 015.334-5.333A5.34 5.34 0 0113.334 8a5.34 5.34 0 01-5.333 5.333z"
}));

const SvgQuestionMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref);

export default SvgQuestionMark;